module.exports = __webpack_public_path__ + "static/img/3.2f2e551.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/3.png
// module id = w3Gl
// module chunks = 4